import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {
  MEETING, SPEED_DATING, THEME_TABLE, CALL_FOR_IMPACT, SPEED_DATING_MEETING,
  SPEED_DATING_RANDOM,
} from 'constants/types';
import { TYPE_CALL_FOR_IMPACT, TYPE_THEME_TABLE } from 'constants/meetings';
import { orange } from 'constants/colors';
import { EVENT, TABLE } from 'constants/speed_dating';
import callIcon from 'assets/images/calls/callIconBlack.svg';
import speedDatingLogo from 'assets/images/hall/speedDatingLogoGreen.svg';
import liveEventLogo from 'assets/images/hall/liveEventLogo.svg';
import insightsLogo from 'assets/images/hall/insightsLogo.svg';
import tableIcon from 'assets/images/calls/tableBlack.svg';
import microIcon from 'assets/images/calls/micro.svg';
import clockIcon from 'assets/images/calls/clock.svg';
import misteryIcon from 'assets/images/speed_dating/mistery.svg';
import Avatar from 'components/Avatar';
import {
  AgendaCardWrapper, Top, Data, Footer,
} from './styles';

function AgendaCard(props) {
  const {
    literals, data, type, narratives, history, speedDatingMeetings, isDragging,
  } = props;
  const [deployMenu, setDeployMenu] = useState(false);
  const [color, setColor] = useState('#FFA304');
  useEffect(() => {
    switch (type) {
      case MEETING:
        setColor('#FFA304');
        break;
      case SPEED_DATING:
        setColor('#2680EB');
        break;
      case SPEED_DATING_MEETING:
        setColor('#2680EB');
        break;
      case SPEED_DATING_RANDOM:
        setColor('#2680EB');
        break;
      default:
        setColor('#FFA304');
        break;
    }
  }, [type]);

  const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

  const startDatetime = new Date(data.start_date * 1000);
  const endDatetime = new Date(data.end_date * 1000);
  const month = months[startDatetime.getMonth()];
  const day = startDatetime.getDate();
  let dayOfMonth = '';
  if (day === 1 || day === 21 || day === 31) {
    dayOfMonth = `${day}st`;
  } else if (day === 2 || day === 22) {
    dayOfMonth = `${day}nd`;
  } else if (day === 3 || day === 23) {
    dayOfMonth = `${day}rd`;
  } else {
    dayOfMonth = `${day}th`;
  }

  let startMinutes = startDatetime.getMinutes();
  if (startMinutes < 10) {
    startMinutes = `0${startMinutes}`;
  }

  let endMinutes = endDatetime.getMinutes();
  if (endMinutes < 10) {
    endMinutes = `0${endMinutes}`;
  }

  const startHour = `${startDatetime.getHours()}:${startMinutes}`;
  const endHour = `${endDatetime.getHours()}:${endMinutes}`;

  let hour = `${startHour} to ${endHour}`;

  if (!data.end_date) {
    hour = startHour;
  }

  const printContent = () => {
    switch (type) {
      case SPEED_DATING: {
        const numSpeedDatings = _.filter(speedDatingMeetings, { element_id: data.id }).length;

        const callInfo = _.find(narratives, (narrative) => {
          return _.find(narrative.theme_tables, themeTable => themeTable === data.element.id);
        });

        let callForImpact = null;

        if (callInfo) {
          callForImpact = (
            <div className='line_content'>
              <img src={callIcon} alt='' style={{ height: '1.5rem' }} />
              <div className='text'>{callInfo.name}</div>
            </div>
          );
        }

        return (
          <React.Fragment>
            {data.element.type === CALL_FOR_IMPACT ? (
              <div className='line_content'>
                <img src={callIcon} alt='' style={{ height: '1.5rem' }} />
                <div className='text'>{data.element.name}</div>
              </div>
            ) : null}
            {data.element.type === THEME_TABLE ? (
              <div className='line_content'>
                <img src={tableIcon} alt='' style={{ height: '1.5rem' }} />
                <div className='text'>{data.element.name}</div>
              </div>
            ) : null}
            {data.element_type.id === TABLE && callForImpact}
            <div className='line_content green'>
              <img src={clockIcon} alt='' style={{ height: '1.5rem' }} />
              <div className='text'>
                {'Starting at '}
                <strong>{hour}</strong>
              </div>
            </div>
          </React.Fragment>
        );
      }
      case SPEED_DATING_RANDOM:
        return (
          <React.Fragment>
            <div className='mystery_title'>{literals.mysteryDate}</div>
            <div className='line_content'>
              <img src={misteryIcon} className='mistery_icon' alt='' />
            </div>
            <div className='line_content' style={{ marginTop: '2.5rem' }}>
              <img src={clockIcon} alt='' style={{ height: '1.5rem', backgroundColor: '#fff', borderRadius: '50%' }} />
              <div className='text'>
                {'Starting at '}
                <strong style={{ color: '#fff' }}>{hour}</strong>
              </div>
            </div>
          </React.Fragment>
        );
      case SPEED_DATING_MEETING:
        return (
          <React.Fragment>
            {data.element ? (
              <div className='line_content'>
                <img src={callIcon} alt='' style={{ height: '1.5rem' }} />
                <div className='text'>{data.element.name}</div>
              </div>
            ) : null}
            <div className='line_content'>
              <Avatar size={32} avatar={data.user.avatar} firstname={data.user.firstname} />
              <div className='text'>{`${data.user.firstname} ${data.user.lastname}`}</div>
            </div>
            <div className='line_content'>
              <img src={clockIcon} alt='' style={{ height: '1.5rem' }} />
              <div className='text'><strong>{hour}</strong></div>
            </div>
          </React.Fragment>
        );
      case MEETING: {
        const speakers = data.speakers.map(speaker => (
          <div className='line_content' key={speaker.id}>
            <img src={microIcon} alt='' style={{ height: '1.5rem' }} />
            <div>
              <div className='text'>{literals.speaker}</div>
              <div className='user'>
                <Avatar size={16} avatar={speaker.avatar} firstname={speaker.firstname} />
                {`${speaker.firstname} ${speaker.lastname}`}
              </div>
            </div>
          </div>
        ));

        let callForImpact = null;
        let table = null;

        if (data.element.type === TYPE_THEME_TABLE) {
          table = (
            <div className='line_content'>
              <img src={tableIcon} alt='' style={{ height: '1.5rem' }} />
              <div className='text'>{data.element.name}</div>
            </div>
          );

          const callInfo = _.find(narratives, (narrative) => {
            return _.find(narrative.theme_tables, themeTable => themeTable === data.element.id);
          });

          if (callInfo) {
            callForImpact = (
              <div className='line_content'>
                <img src={callIcon} alt='' style={{ height: '1.5rem' }} />
                <div className='text'>{callInfo.name}</div>
              </div>
            );
          }
        }

        if (data.element.type === TYPE_CALL_FOR_IMPACT) {
          callForImpact = (
            <div className='line_content'>
              <img src={callIcon} alt='' style={{ height: '1.5rem' }} />
              <div className='text'>{data.element.name}</div>
            </div>
          );
        }

        return (
          <React.Fragment>
            {callForImpact}
            {table}
            {speakers}
            <div className='line_content'>
              <img src={clockIcon} alt='' style={{ height: '1.5rem' }} />
              <div className='text'><strong>{hour}</strong></div>
            </div>
          </React.Fragment>
        );
      }
      default:
        return null;
    }
  };

  const handleClick = () => {
    if (!isDragging) {
      switch (type) {
        case MEETING:
          history.push(`/zoom-meeting/${data.zoom_data.id}`);
          break;
        case SPEED_DATING_RANDOM:
          history.push(`/speed-dating/${data.id}/random`);
          break;
        case SPEED_DATING_MEETING:
          history.push(`/zoom-meeting/${data.zoom_data.id}`);
          break;
        case SPEED_DATING:
          history.push(`/speed-dating/${data.id}`);
          break;
        default:
          break;
      }
    }
  };

  let image = liveEventLogo;
  let typeName = literals.liveEvent;

  switch (type) {
    case SPEED_DATING:
      image = speedDatingLogo;
      typeName = literals.speedDating;
      break;
    case MEETING:
      image = liveEventLogo;
      typeName = literals.liveEvent;
      break;
    case SPEED_DATING_RANDOM:
      image = speedDatingLogo;
      typeName = '';
      break;
    case SPEED_DATING_MEETING:
      image = speedDatingLogo;
      typeName = literals.speedDating;
      break;
    default:
      image = insightsLogo;
      typeName = literals.conclusions;
      break;
  }

  let backColor = color;

  if (type === SPEED_DATING || type === SPEED_DATING_RANDOM) {
    backColor = '#8AD923';
  }

  return (
    <AgendaCardWrapper className='agenda_card' onClick={type === SPEED_DATING ? null : handleClick} color={backColor !== color ? backColor : ''}>
      <Top color={backColor} type={type}>
        <div className='icon'>
          <img src={image} alt='' />
        </div>
        <div className='data'>{`${month} ${dayOfMonth}`}</div>
        <div className='type_card'>
          {typeName && data.element_type && data.element_type.id === EVENT ? literals.event : null}
          {typeName && data.element_type && data.element_type.id === TABLE ? literals.table : null}
          {' '}
          {typeName}
        </div>
      </Top>
      <Data type={type} color={type === SPEED_DATING ? 'white' : orange}>
        {printContent()}
      </Data>
      {type === SPEED_DATING ? (
        <Footer>
          <button type='button' onClick={handleClick}>
            {literals.plan}
          </button>
        </Footer>
      ) : null}
    </AgendaCardWrapper>
  );
}

AgendaCard.propTypes = {
  data: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired,
  literals: PropTypes.object.isRequired,
  narratives: PropTypes.array.isRequired,
  speedDatingMeetings: PropTypes.array.isRequired,
  isDragging: PropTypes.bool,
};

AgendaCard.defaultProps = {
  isDragging: false,
};

export default AgendaCard;



// WEBPACK FOOTER //
// ./src/components/Cards/AgendaCard/components/index.jsx